/** Рабочее место устройства: «Работа» или «Дом» */
export enum EnumWorkspace {
  WORK = 'work',
  HOME = 'home',
}

/** Значение от узла или из памяти браузера; неизвестное или пустое — «Дом» */
export function toWorkspace(value: unknown): EnumWorkspace {
  return value === EnumWorkspace.WORK ? EnumWorkspace.WORK : EnumWorkspace.HOME
}
